import { render, staticRenderFns } from "./OcrPreviewModal.vue?vue&type=template&id=c2051274&scoped=true"
import script from "./OcrPreviewModal.vue?vue&type=script&lang=js"
export * from "./OcrPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./OcrPreviewModal.vue?vue&type=style&index=0&id=c2051274&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2051274",
  null
  
)

export default component.exports